import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EuiUserProfileModule } from '../../eui-user-profile/user-profile.module';
import { EuiLanguageSelectorModule } from '../../eui-language-selector/language-selector.module';

import { EuiAppHeaderComponent } from './header.component';
import { EuiSidebarToggleModule } from '../../eui-sidebar-toggle';

@NgModule({
    imports: [
        CommonModule, RouterModule,
        EuiSidebarToggleModule,
        EuiUserProfileModule,
        EuiLanguageSelectorModule,
        RouterModule,
    ],
    declarations: [
        EuiAppHeaderComponent,
    ],
    exports: [
        EuiAppHeaderComponent,
    ],
})
export class EuiAppHeaderModule { }
